//! вывод годов в фильтр от 2025 и далее по факту наступления след года
export const years = generateYears(2025, new Date().getFullYear());

function generateYears(fromYear: number, toYear: number) {
  const years = [];
  for (let year = fromYear; year <= toYear; year++) {
    years.push({ ID: year - fromYear + 1, Title: String(year) });
  }
  return years;
}

export const months = [
  { ID: 1, Title: 'Январь' },
  { ID: 2, Title: 'Февраль' },
  { ID: 3, Title: 'Март' },
  { ID: 4, Title: 'Апрель' },
  { ID: 5, Title: 'Май' },
  { ID: 6, Title: 'Июнь' },
  { ID: 7, Title: 'Июль' },
  { ID: 8, Title: 'Август' },
  { ID: 9, Title: 'Сентябрь' },
  { ID: 10, Title: 'Октябрь' },
  { ID: 11, Title: 'Ноябрь' },
  { ID: 12, Title: 'Декабрь' },
];

const getCurrentDate = () => {
  const months = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonthIndex = currentDate.getMonth();

  return {
    month: {
      id: currentMonthIndex + 1,
      name: months[currentMonthIndex],
    },
    year: {
      id: currentYear,
      name: currentYear.toString(),
    },
  };
};

const currentDate = getCurrentDate();

export const initialFiltersReportFactory = {
  yearFactory: {
    selected: [currentDate.year.name],
    selectedIds: [currentDate.year.id],
    search: '',
  },
  monthFactory: {
    selected: [currentDate.month.name],
    selectedIds: [currentDate.month.id],
    search: '',
  },
  column: { selected: ['Менеджмент', 'Качество', 'Люди', 'Экология', 'Техобслуживание', 'Безопасность', 'Логистика'], selectedIds: [4, 5, 6, 7, 8, 9, 10], search: '' },
  columnBlockFactory: { selected: [], selectedIds: [], search: '' },

  subdivisionFactory: { selected: [], selectedIds: [], search: '' },

  groupPlanAction: { selected: ['BOP'], selectedIds: [24] },
  reportFactory: { selected: ['Владивосток'], selectedIds: [2] },
};

export const initialOpenReportFactory = {
  yearFactory: false,
  monthFactory: false,
  column: false,
  groupPlanAction: false,
  reportFactory: false,
  columnBlockFactory: false,
  subdivisionFactory: false
};

export const filterConfigReportFactory = {
  yearFactory: {
    title: 'Год',
    hasSearch: false,
    searchPlaceholder: 'Поиск по году',
    options: years.map((item) => item.Title),
  },
  monthFactory: {
    title: 'Месяц',
    hasSearch: true,
    searchPlaceholder: 'Поиск по месяцу',
    options: months.map((item) => item.Title),
  },
  column: {
    title: 'Колонна',
    options: [],
    searchPlaceholder: 'Найти колонну',
  },
  groupPlanAction: {
    title: 'Группа',
    options: [],
    hasSearch: false,
  },
  reportFactory: {
    title: 'Завод',
    options: [],
    hasSearch: false,
  },
  columnBlockFactory: {
    title: 'Блок колонны',
    options: [],
    searchPlaceholder: 'Найти блок колонны',
  },
  subdivisionFactory: {
    title: 'Подразделение',
    options: [],
    searchPlaceholder: 'Найти подразделение',
  }
};
